<template lang="pug">
//- 個教預約
.personal-index.page-Index 
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'

export default {
  name: 'Index',
  components: {
    ContentTop
  },
  data () {
    return {
    };
  },
  async created () {
    this.$root.closeLoading()
  },
  mounted () {
  },
  computed: {
  },
  methods: {

  }
}
</script>
<style lang="sass">
</style>
